{
  "corporatePortal": {
    "corporateDetails": {
      "header": "Company account details",
      "edit": "Edit company details"
    }
  }
}
